import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "account-icon me-3" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ps-3" }
const _hoisted_5 = { class: "small" }
const _hoisted_6 = { class: "small" }
const _hoisted_7 = { class: "small" }

import Teacher from '../../../api/v2/models/teacher'


export default /*@__PURE__*/_defineComponent({
  __name: 'TeacherView',
  props: {
    teacher: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.teacher.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "img-fluid",
            style: {"clip-path":"circle()","width":"100%"},
            src: __props.teacher.image.url
          }, null, 8 /* PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.teacher.name) + "先生", 1 /* TEXT */),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.teacher.catch), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("strong", null, "わかりやすい " + _toDisplayString(__props.teacher.pointCount) + "pt", 1 /* TEXT */)
      ])
    ])
  ]))
}
}

})